import { Link } from "react-router-dom";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const institutions = [
  "Princeton", "TU Darmstadt", "NAVER AI Lab", "Northeastern University", "U of Toronto"
];

const conferences = ["NeurIPS 2025", "AAAI 2025", "KDD 2024"];

const Credibility = () => {
  const ref = useScrollReveal();

  return (
    <section ref={ref} className="py-10 md:py-16 px-4">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-4">
          Built on peer-reviewed research
        </h2>
        <p className="text-muted-foreground leading-relaxed mb-10 max-w-xl mx-auto">
          AILens scoring methodology is grounded in published academic research.
          Every decision is based on data, not marketing claims.
        </p>

        <p className="text-xs font-mono uppercase tracking-wider text-muted-foreground mb-3">
          Research cited from teams at
        </p>
        <div className="flex flex-col items-center gap-y-1 md:flex-row md:flex-wrap md:justify-center md:gap-x-8 md:gap-y-2 mb-6">
          {institutions.map((name) => (
            <span key={name} className="uppercase font-bold text-sm tracking-widest text-muted-foreground/80 md:text-muted-foreground/60">
              {name}
            </span>
          ))}
        </div>

        <div className="flex flex-wrap justify-center gap-3 mb-8">
          {conferences.map((c) => (
            <span
              key={c}
              className="text-xs font-mono uppercase tracking-widest font-bold px-3 py-1 border border-border/40 text-muted-foreground/60"
            >
              {c}
            </span>
          ))}
        </div>

        <Link
          to="/methodology"
          className="text-sm font-medium text-foreground underline hover:no-underline"
        >
          See our full methodology →
        </Link>
      </div>
    </section>
  );
};

export default Credibility;
